export const getPricingOfAccountSmsCampaign = {
  GET_PRICING_OF_ACCOUNT_SMS_CAMPAIGN_REQUEST: "GET_PRICING_OF_ACCOUNT_SMS_CAMPAIGN_REQUEST",
  GET_PRICING_OF_ACCOUNT_SMS_CAMPAIGN_SUCCESS: "GET_PRICING_OF_ACCOUNT_SMS_CAMPAIGN_SUCCESS",
  GET_PRICING_OF_ACCOUNT_SMS_CAMPAIGN_ERROR: "GET_PRICING_OF_ACCOUNT_SMS_CAMPAIGN_ERROR",
};

export const editPricingOfAccountSmsCampaign = {
  EDIT_PRICING_OF_ACCOUNT_SMS_CAMPAIGN_REQUEST: "EDIT_PRICING_OF_ACCOUNT_SMS_CAMPAIGN_REQUEST",
  EDIT_PRICING_OF_ACCOUNT_SMS_CAMPAIGN_SUCCESS: "EDIT_PRICING_OF_ACCOUNT_SMS_CAMPAIGN_SUCCESS",
  EDIT_PRICING_OF_ACCOUNT_SMS_CAMPAIGN_ERROR: "EDIT_PRICING_OF_ACCOUNT_SMS_CAMPAIGN_ERROR",
};
